import React, { useEffect } from "react";
import { db } from "../firebase"; // Adjust the path if your firebase.js file is located elsewhere
import { collection, addDoc } from "firebase/firestore";

const FirestoreTest = () => {
  useEffect(() => {
    const saveGameResult = async () => {
      try {
        // Reference to the gameResults subcollection
        const resultsRef = collection(db, "users", "guest_user", "gameResults");

        // Game result data
        const result = {
          score: 200, // Replace with your test score
          correctAnswers: 15, // Replace with your test correctAnswers
          incorrectAnswers: 5, // Replace with your test incorrectAnswers
          date: new Date().toISOString(), // Current date
        };

        // Add the game result to Firestore
        const docRef = await addDoc(resultsRef, result);
        console.log("Game result saved with ID:", docRef.id);
      } catch (error) {
        console.error("Error saving game result:", error);
      }
    };

    saveGameResult();
  }, []);

  return <div>Saving game result to Firestore...</div>;
};

export default FirestoreTest;
